import { useRef } from "react";
import { FiSliders } from "react-icons/fi";
import { StatSelect } from "./components/StatSelect";
import { StatsFilterModal } from "../../../components/coach/dashboard/StatsFilterModal";
import { SimpleDropdown } from "../../../components/common/SimpleDropdown";
import scoutProfileService from "../../../services/scoutProfileService";

export const RecentTeamStats = ({
  onFiltersClick,
  showFilterModal,
  onCloseModal,
  onApplyFilters,
  stats = {},
  statsType = 'overall',
  onStatsTypeChange,
  category = 'hitting',
  onCategoryChange,
}) => {
  const buttonRef = useRef(null);

  // Dropdown options for stats type
  const statsTypeOptions = [
    { value: "overall", label: "Overall Stats" },
    { value: "conference", label: "Conference Stats" },
  ];

  // Dropdown options for category
  const categoryOptions = [
    { value: "", label: "Full Roster" },
    { value: "hitting", label: "Hitters" },
    { value: "pitching", label: "Pitchers" },
  ];

  return (
    <div className="flex flex-col lg:flex-row lg:items-center justify-between py-4 gap-3 relative">

      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-semibold text-white mb-2 text-center lg:text-left">
          2025-2026 Roster
        </h3>

        {/* Stats Type & Category Dropdowns */}
        <div className="flex flex-wrap items-center gap-3">
          {onStatsTypeChange && (
            <div style={{ minWidth: '150px' }} className="[&_button]:h-8 [&_button]:py-0 [&_button]:px-3 [&_button]:text-[11px] [&_button]:!border [&_button]:border-white/70 [&_svg]:!w-3 [&_svg]:!h-3">
              <SimpleDropdown
                value={statsType}
                onChange={onStatsTypeChange}
                options={statsTypeOptions}
                placeholder="Overall Stats"
                variant="pill"
              />
            </div>
          )}
          {onCategoryChange && (
            <div style={{ minWidth: '130px' }} className="[&_button]:h-8 [&_button]:py-0 [&_button]:px-3 [&_button]:text-[11px] [&_button]:!border [&_button]:border-white/70 [&_svg]:!w-3 [&_svg]:!h-3">
              <SimpleDropdown
                value={category}
                onChange={onCategoryChange}
                options={categoryOptions}
                placeholder="Full Roster"
                variant="pill"
              />
            </div>
          )}
        </div>
      </div>

      {/* Right: text + icon, no pill/button box in desktop look */}
      <button
        ref={buttonRef}
        type="button"
        onClick={onFiltersClick}
        className="self-start lg:self-center inline-flex items-center gap-2 text-white text-sm whitespace-nowrap
                   px-0 py-0 hover:text-cyan-200 transition-colors"
      >
        Add/Subtract Filters
        <FiSliders className="text-white" size={18} />
      </button>

      {/* Stats Filter Modal */}
      <StatsFilterModal
        isOpen={showFilterModal}
        onClose={onCloseModal}
        onApply={onApplyFilters}
        buttonRef={buttonRef}
        profileService={scoutProfileService}
      />
    </div>
  );
};
